import type { FieldDto } from "../../types/field";
import { isFieldOptionsObject } from "./fieldOptions";

export type DisplayConfig = {
  content?: string;
  image_url?: string;
};

export function resolveDisplayConfig(field: FieldDto): DisplayConfig {
  const fromDisplay = field.display;
  const options = isFieldOptionsObject(field.options) ? field.options : null;

  return {
    content: String(fromDisplay?.content ?? options?.content ?? "").trim(),
    image_url: String(
      fromDisplay?.image_url ?? options?.image_url ?? "",
    ).trim(),
  };
}

export function hasDisplayContent(config: DisplayConfig): boolean {
  return Boolean(config.content || config.image_url);
}
